import styles from "./accountlistfilter.module.css";
import { Link } from "react-router-dom";
import { Autocomplete, FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import { ArrowRight, Filter, Plus, Search } from "react-feather";
import { useState } from "react";

const AccountListFilter = ({ setShowTuyaAddFormNew, setFilterData, setPage, propertyList, filterData }) => {
    const [showFilter, setShowFilter] = useState(false);
    const [apartmentList, setApartmentList] = useState([]);
    const [selectedProperty, setSelectedProperty] = useState(0);

    const selectProperty = (e) => {
        if (e.target.value === 'all') {
            setSelectedProperty(0);
            setApartmentList([]);
        } else {
            setSelectedProperty(e.target.value);
            let apartmentListTemp = [];
            let selProperty = propertyList?.filter(i => i.value === e.target.value);

            if (selProperty && selProperty.length > 0) {
                apartmentListTemp = selProperty[0].apartments;
            }

            setApartmentList(apartmentListTemp);
        }
    }

    return (<div className={`${styles.SearchFilterSec}`}>
        <div className={`${styles.SearchCon}`}>
            <div className={`${styles.SearchConSec}`}>
                <Search />
                <input type="text" placeholder="Search" onChange={(e) => {
                    setFilterData((prev) => { return { ...prev, searchKey: e.target.value }; });
                    setPage(0);
                }} />
            </div>
        </div>
        <div className={`${styles.FilterSec}`}>
            <div className={!showFilter ? `${styles.FilterFieldSec}` : `${styles.FilterFieldSec} ${styles.Open}`}>
                <p className={`${styles.FilterTitle}`}>
                    Filters
                    <span onClick={(e) => setShowFilter(false)}>
                        <ArrowRight />
                    </span>
                </p>
                <div className={`${styles.FilterCard} ${styles.Select} CusSelectFilter Filter`}>
                    <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">Property</InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            label="Property"
                            onChange={(e) => {
                                setFilterData((prev) => { return { ...prev, property: e.target.value, apartment: '' }; });
                                setPage(0);
                                selectProperty(e);
                            }}
                        >
                            <MenuItem value={'all'}>All</MenuItem>
                            {propertyList?.map(i => {
                                return <MenuItem value={i?.value}>{i?.label}</MenuItem>
                            })}
                        </Select>
                    </FormControl>
                </div>
                <div className={`${styles.FilterCard} ${styles.Select} CusSelectFilter Filter`}>
                    <FormControl fullWidth>
                        <Autocomplete
                            options={apartmentList || []}
                            getOptionLabel={(option) => option.label || ""}
                            renderInput={(params) => (<TextField {...params} label="Select Apartment*" />)}
                            value={apartmentList?.find((opt) => opt.value === filterData.apartment) || null}
                            noOptionsText={selectedProperty ? "No apartments found" : "Select property first"}
                            onChange={(event, newValue) => {
                                setFilterData((prev) => { return { ...prev, apartment: newValue?.value || '' }; });
                                setPage(0);
                            }}
                        />
                    </FormControl>
                </div>
                <div className={`${styles.FilterCard} ${styles.Select} CusSelectFilter Filter`}>
                    <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">Type</InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            label="Type"
                            onChange={(e) => {
                                setFilterData((prev) => { return { ...prev, type: e.target.value }; });
                                setPage(0);
                            }}
                        >
                            <MenuItem value={'all'}>All</MenuItem>
                            <MenuItem value={'Tuya'}>Tuya</MenuItem>
                        </Select>
                    </FormControl>
                </div>
            </div>
            <Link className={`${styles.FilterBu}`} onClick={(e) => setShowFilter(true)}>
                <Filter />
            </Link>
            <Link className={`${styles.AddNoteBu}`} onClick={(e) => setShowTuyaAddFormNew(true)}>
                <Plus /> <span>IoT Account</span>
            </Link>
        </div>
    </div >)
}


export default AccountListFilter;